"use strict";
// Helper functions that may or may not be used by the Popover component.
Object.defineProperty(exports, "__esModule", { value: true });
// Converts a full placement to one of the four positions by stripping text after the `-`.
function getPosition(placement) {
    return placement.split('-')[0];
}
exports.getPosition = getPosition;
// Returns true if position is left or right.
function isVerticalPosition(side) {
    return ['left', 'right'].indexOf(side) !== -1;
}
exports.isVerticalPosition = isVerticalPosition;
// Returns the opposite position.
function getOppositePosition(side) {
    switch (side) {
        case 'top':
            return 'bottom';
        case 'left':
            return 'right';
        case 'bottom':
            return 'top';
        default:
            return 'left';
    }
}
exports.getOppositePosition = getOppositePosition;
// Returns the CSS alignment keyword corresponding to given placement.
function getAlignment(placement) {
    var align = placement.split('-')[1];
    switch (align) {
        case 'start':
            return 'left';
        case 'end':
            return 'right';
        default:
            return 'center';
    }
}
exports.getAlignment = getAlignment;
// Popper modifiers
// ================
// Modifier helper function to compute popper transform-origin based on arrow position
function getTransformOrigin(data) {
    var position = getPosition(data.placement);
    if (data.arrowElement == null) {
        return isVerticalPosition(position)
            ? getOppositePosition(position) + " " + getAlignment(position)
            : getAlignment(position) + " " + getOppositePosition(position);
    }
    else {
        var arrowSizeShift = data.arrowElement.clientHeight / 2;
        var arrow = data.offsets.arrow;
        // can use keyword for dimension without the arrow, to ease computation burden.
        // move origin by half arrow's height to keep it centered.
        return isVerticalPosition(position)
            ? getOppositePosition(position) + " " + (arrow.top + arrowSizeShift) + "px"
            : arrow.left + arrowSizeShift + "px " + getOppositePosition(position);
    }
}
exports.getTransformOrigin = getTransformOrigin;
// additional space between arrow and edge of target
var ARROW_SPACING = 4;
// Popper modifier that offsets popper and arrow so arrow points out of the correct side
exports.arrowOffsetModifier = function (data) {
    if (data.arrowElement == null) {
        return data;
    }
    // our arrows have equal width and height
    var arrowSize = data.arrowElement.clientWidth;
    // this logic borrowed from original Popper arrow modifier itself
    var position = getPosition(data.placement);
    var isVertical = isVerticalPosition(position);
    var len = isVertical ? 'width' : 'height';
    var offsetSide = isVertical ? 'left' : 'top';
    var arrowOffsetSize = Math.round(arrowSize / 2 / Math.sqrt(2));
    // offset popover by arrow size, offset arrow in the opposite direction
    if (position === 'top' || position === 'left') {
        // the "up & back" directions require negative popper offsets
        data.offsets.popper[offsetSide] -= arrowOffsetSize + ARROW_SPACING;
        // can only use left/top on arrow so gotta get clever with 100% + X
        data.offsets.arrow[offsetSide] =
            data.offsets.popper[len] - arrowSize + arrowOffsetSize;
    }
    else {
        data.offsets.popper[offsetSide] += arrowOffsetSize + ARROW_SPACING;
        data.offsets.arrow[offsetSide] = -arrowOffsetSize;
    }
    return data;
};
// Returns whether the value is a function. Acts as a type guard.
// tslint:disable-next-line:ban-types
function isFunction(value) {
    return typeof value === 'function';
}
exports.isFunction = isFunction;
// tslint:disable-next-line:ban-types
function safeInvoke(func) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (isFunction(func)) {
        return func.apply(void 0, args);
    }
}
exports.safeInvoke = safeInvoke;
// tslint:disable-next-line:ban-types
function safeInvokeOrValue(funcOrValue) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return isFunction(funcOrValue) ? funcOrValue.apply(void 0, args) : funcOrValue;
}
exports.safeInvokeOrValue = safeInvokeOrValue;
function elementIsOrContains(element, testElement) {
    return element === testElement || element.contains(testElement);
}
exports.elementIsOrContains = elementIsOrContains;
//# sourceMappingURL=popperUtils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/Popover/popperUtils.js
// module id = 265
// module chunks = 0